
import { mapState } from 'vuex';
import moment from 'moment'
export default {
  name: 'LocationSelectedDelivery',
  props: {
    order: Object,
    config: Object
  },
  computed: {
    ...mapState(['location', 'cart']),
    ...mapState({
      deliveryAddress: state => state.locations.deliveryAddress,
      handoffMode: state => state.order.handoffMode,
    }),
    handoffIcon() {
      if (this.order.orderMode === 'advance') {
        return 'clock-icon'
      }
      else if (this.order.orderMode === 'asap') {
        return 'pickup-icon'
      }
    },
    handoffTitle() {
      if (this.cart?.time?.mode === 'asap') {
        return 'Delivery to'
      }
      else if (this.cart?.time?.mode === 'advance') {
        let formattedTime = moment(this.cart.time.wanted, "YYYYMMDD HH:mm").format("h:mm A dddd MM/DD/YYYY");
        return `Scheduled Delivery at <span>${formattedTime}</span> to:`
      }
    },
    deliveryAddressTitle() {
      if (!this.deliveryAddress) return '';
      let text = this.deliveryAddress.address
      
      if (this.deliveryAddress.building) {
        text += `, ${this.deliveryAddress?.building}`
      }
      return text;
    },
  }
}
